import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import useOrgUnitAdminCredentials from './UseOrgUnitAdminCredentials';

import OrgUnitAdminCredentialsGrid from './OrgUnitAdminCredentialsGrid';

import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

import Constants from '@usas/ui-web/utils/Constants';

const OrgUnitAdminCredentials = () => {
  const { state, oUAdminEntryContextState, onNextButtonClicked, onSaveAndExitButtonClicked, onBackButtonClicked,
    omeMeetOrgUnitNonAthleteEntryState, omeMeetOrgUnitEntryInfoState,
    modalState, onAddCredential, onDeleteCredentialClicked, onModalCanceled, onDeleteCredential
  } = useOrgUnitAdminCredentials();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_CREDENTIALS}
        onNextButtonClicked={onNextButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        onBackButtonClicked={onBackButtonClicked}
        errorMessage={state.error}>
        {oUAdminEntryContextState.isReadOnly === false ?
          <Fragment>
            <div className="row">
              <div className="col-xs-12 usas-extra-top-margin">
                <ActionIntraPageButton type="button" onClick={onAddCredential}>Select Credentials</ActionIntraPageButton>
              </div>
              <div className="col-xs-12">
                <OrgUnitAdminCredentialsGrid
                  gridData={omeMeetOrgUnitNonAthleteEntryState.arrayData}
                  isLoading={omeMeetOrgUnitNonAthleteEntryState.isArrayLoading}
                  onDeleteCredentialClicked={onDeleteCredentialClicked}
                />
              </div>
              {omeMeetOrgUnitNonAthleteEntryState.arrayData?.length > 5 && omeMeetOrgUnitNonAthleteEntryState.isArrayLoading === false &&
                <div className='visible-md visible-lg'>
                  <div className="col-xs-12 usas-extra-top-margin">
                    <ActionIntraPageButton className="usas-extra-top-margin" type="button" onClick={onAddCredential}>Select Credentials</ActionIntraPageButton>
                  </div>
                </div>}
              {omeMeetOrgUnitNonAthleteEntryState.arrayData?.length > 0 && omeMeetOrgUnitNonAthleteEntryState.isArrayLoading === false &&
                <div className='hidden-md hidden-lg'>
                  <div className="col-xs-12 usas-extra-top-margin">
                    <ActionIntraPageButton className="usas-extra-top-margin" type="button" onClick={onAddCredential}>Select Credentials</ActionIntraPageButton>
                  </div>
                </div>}
            </div>
            <PopUpModal
              widthPct={90}
              maxWidth={720}
              title={modalState.modalTitle}
              displayPopUp={modalState.displayPopUp}
              onModalCanceled={onModalCanceled}>
              <div className="row">
                <div className="col-xs-12">
                  <p><strong>Name:</strong> {modalState?.credentialName}</p>
                  <p><strong>Member Id:</strong> {modalState?.memberId}</p>
                  <p><strong>Email:</strong> {modalState?.email}</p>
                  <p><strong>Is In Good Standing?:</strong> {modalState?.isInGoodStanding}</p>
                  <p><strong>Good Standing Expiration Date:</strong> {modalState?.isInGoodStandingExpirationDate}</p>
                  <p><strong>Credential:</strong> {modalState?.typeName}</p>
                </div>
                <div className="col-xs-12 usas-extra-top-margin">
                  <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
                  <PrimaryButton type="button" onClick={(e) => onDeleteCredential(e, modalState.orgUnitNonAthleteEntryId)}>Delete</PrimaryButton>
                </div>
              </div>
            </PopUpModal>
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={omeMeetOrgUnitNonAthleteEntryState.isArrayLoading || omeMeetOrgUnitEntryInfoState.isObjLoading} />
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.SAVING_MSG}
              displayPopUp={omeMeetOrgUnitNonAthleteEntryState.isSaving} />
          </Fragment> :
          <Fragment>
            <div className="row">
              <div className="col-xs-12">
                <OrgUnitAdminCredentialsGrid
                  gridData={omeMeetOrgUnitNonAthleteEntryState.arrayData}
                  isLoading={omeMeetOrgUnitNonAthleteEntryState.isArrayLoading}
                />
              </div>
            </div>
            <PopUpModal
              widthPct={30}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={omeMeetOrgUnitNonAthleteEntryState.isArrayLoading} />
          </Fragment>
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminCredentials;